import { Injectable } from '@angular/core';
import { DriverWithShiftCount } from '../../shared/models/driver.model';
import { DriversService } from './drivers.service';

@Injectable({
  providedIn: 'root'
})
export class DriversManagerService {
  private isInitialized = false;

  private readonly driversMap = new Map<number, DriverWithShiftCount>();

  constructor(
    private driversService: DriversService,
  ) { }

  public init(drivers: DriverWithShiftCount[]) {
    if (this.isInitialized) {
      throw Error('The DriversManagerService has already been initialized.');
    }

    this.addDrivers(drivers);

    this.isInitialized = true;
  }

  public release() {
    if (!this.isInitialized) {
      return;
    }

    this.driversMap.clear();
    this.isInitialized = false;
  }

  public async getDrivers(): Promise<DriverWithShiftCount[]> {
    if (this.isInitialized) {
      return [...this.driversMap.values()];
    } else {
      const driverResponse = await this.driversService.getDriverList();
      return driverResponse.data;
    }
  }

  public getDriver(driverId: number): DriverWithShiftCount|null {
    return this.driversMap.get(driverId);
  }

  private addDrivers(newDrivers: DriverWithShiftCount[]) {
    for (const driver of newDrivers) {
      this.driversMap.set(driver.id, driver);
    }
  }
}
